import { object, string } from 'yup';

import { phoneNumberRegex, removeNonDigits } from '@sbv-clients/util-misc';

export const schema = object({
  phoneNumber: string()
    .required()
    .label('Phone Number')
    .default('')
    .transform((value) => value.replace(removeNonDigits, ''))
    .matches(phoneNumberRegex, 'Phone number must be 10 digits'),
});
